import { Stack } from "@mui/material";
import { CustomCheckbox, ReuseEllipsisTooltip } from "../ui";
import { TableColumnType } from "../../types/genereal";

type Props = {
  columns: TableColumnType[];
  isSelectedAll: boolean;
  selectAllHandler: () => void;
  isDisabled: boolean;
};

export const RecommendedListHeader = ({
  columns,
  isSelectedAll,
  selectAllHandler,
  isDisabled,
}: Props) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        width: "100%",
      }}
    >
      {columns.map(({ key, label, minWidth, maxWidth, bgColor, textAlign }) => {
        if (key === "checkbox") {
          return (
            <Stack
              key={key}
              sx={{
                minWidth,
                maxWidth,
                borderBottom: bgColor ? "none" : "1px solid #DEDEDE",
                backgroundColor: bgColor,
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CustomCheckbox
                checked={isSelectedAll}
                onChange={selectAllHandler}
                disabled={isDisabled}
              />
            </Stack>
          );
        }
        return (
          <Stack
            key={key}
            sx={{
              minWidth,
              maxWidth,
              borderBottom: bgColor ? "none" : "1px solid #DEDEDE",
              backgroundColor: bgColor,
              p: "16px 0 16px 16px",
              width: "100%",
            }}
          >
            <ReuseEllipsisTooltip
              tooltip={label}
              children={label}
              style={{
                fontSize: "14px",
                lineHeight: "26px",
                fontWeight: 500,
                color: "#232323",
                textAlign: textAlign,
              }}
            />
          </Stack>
        );
      })}
    </Stack>
  );
};
